
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemsDialog extends Common.GridEditorDialog<GiftVoucherItemsRow> {
        protected getFormKey() { return GiftVoucherItemsForm.formKey; }
        //protected getIdProperty() { return GiftVoucherItemsRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherItemsRow.localTextPrefix; }
        //protected getService() { return GiftVoucherItemsService.baseUrl; }
        //protected getDeletePermission() { return GiftVoucherItemsRow.deletePermission; }
        //protected getInsertPermission() { return GiftVoucherItemsRow.insertPermission; }
        //protected getUpdatePermission() { return GiftVoucherItemsRow.updatePermission; }

        protected form = new GiftVoucherItemsForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Quantity);

            var value = 0; var giftid = 0; var mininvoice = 0; var code = "";
            this.form.GiftMasterId.changeSelect2(e => {
                this.form.Quantity.value = 0;
                this.form.ItemDetails.emptygrid();
                var giftdetails = OMS.GiftVoucherMasterRow.getLookup().itemById[this.form.GiftMasterId.value];
                value = giftdetails.Value;
                giftid = parseInt(this.form.GiftMasterId.value);
                mininvoice = giftdetails.MinInvoiceValue;
                code = giftdetails.Code;

            });
            this.form.Quantity.changeSelect2(e => {
                var quantity = parseInt(this.form.Quantity.value.toString());
                this.form.ItemDetails.setValue(quantity, value, code, mininvoice, giftid);
            });
        }
        //protected updateInterface(): void {

        //    super.updateInterface();

        //    // finding all editor elements and setting their readonly attribute
        //    // note that this helper method only works with basic inputs, 
        //    // some editors require widget based set readonly overload (setReadOnly)
        //    //Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);

        //    // remove required asterisk (*)
        //    this.element.find('sup').remove();
        //    this.applyChangesButton.remove();
        //    this.saveAndCloseButton.remove();
        //    this.deleteButton.remove();
        //    this.form.ItemDetails.element.find('.add-button').addClass('hidden');
        //    q.hideImageToolbar(this.form.ItemDetails.element);
        //}
    }
    
}